import MUIDialogTitle, {
  type DialogTitleProps as MUIDialogTitleProps,
} from '@mui/material/DialogTitle';
import Stack, { type StackProps } from '@mui/material/Stack';
import { DialogCloseButton } from './dialog-close-button';

export interface DialogTitleProps extends MUIDialogTitleProps {
  onClose?: () => void;
  containerProps?: StackProps;
}

export function DialogTitle({
  onClose,
  containerProps,
  ...props
}: DialogTitleProps) {
  return (
    <Stack
      direction="row"
      p={3}
      pr={onClose ? 8 : 3}
      alignItems="flex-start"
      justifyContent="space-between"
      position="relative"
      {...containerProps}
    >
      <MUIDialogTitle p="0 !important" width="100%" {...props} />
      {typeof onClose === 'function' && (
        <DialogCloseButton
          onClick={onClose}
          autoFocus
          sx={{
            position: 'absolute',
            right: 24,
          }}
        />
      )}
    </Stack>
  );
}
